import { render, staticRenderFns } from "./power_role.vue?vue&type=template&id=6c94c1d5&scoped=true&"
import script from "./power_role.vue?vue&type=script&lang=js&"
export * from "./power_role.vue?vue&type=script&lang=js&"
import style0 from "./power_role.vue?vue&type=style&index=0&id=6c94c1d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94c1d5",
  null
  
)

export default component.exports